<template>
  <b-modal
    v-model="showModal"
    title="Bill Details"
    size="xl"
    centered
    no-close-on-backdrop
    ok-only
    ok-title="Close"
    @ok="$emit('modal-closed')"
    @close="$emit('modal-closed')"
  >

    <b-alert
      variant="danger"
      :show="errorMessage ? true : false"
    >
      <div
        v-if="typeof errorMessage === 'object'"
        class="alert-body"
      >
        <p
          v-for="(message, index) in errorMessage"
          :key="index"
        >
          {{ message }}
        </p>
      </div>
      <p
        v-else
        class="alert-body"
      >
        {{ errorMessage }}
      </p>
    </b-alert>
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>
    <div v-if="data && !loading">
      <b-table-simple
        responsive
        hover
        class="compact-table"
      >
        <b-tbody>
          <b-tr>
            <b-th> Bill No </b-th>
            <b-td> {{ billData.bill_no }} </b-td>
            <b-th> Buyer </b-th>
            <b-td> {{ billData.party__identifier }} </b-td>
          </b-tr>
          <b-tr>
            <b-th>Date</b-th>
            <b-td> {{ billData && formatedDate(billData.date) || '-' }} </b-td>
            <b-th> Amount </b-th>
            <b-td> {{ formateNumber(billData.amount) }} </b-td>
          </b-tr>
          <b-tr>
            <b-th> Mode </b-th>
            <b-td> {{ billData.mode }} </b-td>
            <b-th> Payment Status </b-th>
            <b-td> {{ billData.pay_status }} </b-td>
          </b-tr>
          <b-tr>
            <b-th> Due Amount</b-th>
            <b-td>
              {{ formateNumber(billData.due_amount) }}
            </b-td>
            <b-th> Attachments </b-th>
            <b-td>
              <span
                v-for="(item, index) in billData.bill_attachments"
                :key="index"
              >
                <a
                  :href="item.file"
                  target="_blank"
                >
                  <span>View File {{ index+ 1 }} </span>
                  <span v-if="index != billData.bill_attachments.length - 1">, </span>
                </a>

              </span>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div class="timeline-wrapper mt-2">
        <hr class="timeline-line">
        <b-row>
          <b-col>
            <div class="d-flex justify-content-between">
              <div class="text-center">
                <status
                  class="timeline-status"
                  data="CREATED"
                />
                <div v-if="billData.order === null">
                  <b> Call Order</b>
                </div>
                <div v-else>
                  <b> {{ billData.order[0].placed_by_name }}</b>
                  <div>
                    {{ billData.order[0].created_at && formatedDate(billData.order[0].created_at, 'DD-MM-YYYY LT') || '-' }}
                  </div></div>
              </div>
              <div class="text-center">
                <status
                  class="timeline-status"
                  data="CONFIRMED"
                />
                <b> {{ data.generated_by }}</b>
                <div>
                  {{ data.generated_at && formatedDate(data.generated_at, 'DD-MM-YYYY LT') || '-' }}
                </div>
              </div>
              <div class="text-center">
                <status
                  class="timeline-status"
                  data="PACKED"
                  :disabled="!(billData.rack_group_status && billData.rack_group_status.packing_initiated_by_actual || isBillPicked)"
                />
                <div v-if="billData.rack_group_status && billData.rack_group_status.packing_initiated_by_actual || data.picked_by_fullname"><b> {{ billData.rack_group_status.packing_initiated_by_actual || data.picked_by_fullname }}</b>
                  <div v-if="billData.rack_group_status && billData.rack_group_status.packing_initiated_by_actual || data.picked_at">
                    {{ formatedDate(billData.rack_group_status.packing_initiated_at || data.picked_at, 'DD-MM-YYYY LT') }}
                  </div>
                </div>
                <span v-else> Pending </span>
              </div>
              <div
                v-if="data.pick_up_time"
                class="bg-white px-1"
              >
                {{ data.pick_up_time }}
              </div>

              <div
                class="text-center"
              >
                <status
                  data="PICKED"
                  class="timeline-status"
                  :disabled="!isBillPicked"
                />
                <div v-if="isBillPicked">
                  <b> {{ data.picked_by_fullname }} </b>
                  <div class="mb-1">
                    {{ data.picked_at && formatedDate(data.picked_at, 'DD-MM-YYYY LT') || '-' }}
                  </div>
                  <b-button
                    variant="outline-primary"
                    :disabled="unpickedLoader"
                    @click="handleStatusChange('UN-PICK')"
                  >
                    UnPick
                    <b-spinner
                      v-if="unpickedLoader"
                      label="Small Spinner"
                      variant="primary"
                      small
                    />
                  </b-button>
                </div>
                <span v-else> Pending </span>
              </div>
              <div
                v-if="data.delivery_time"
                class="bg-white px-1"
              >
                {{ data.delivery_time }}
              </div>

              <div class="text-center">
                <status
                  data="DELIVERED"
                  class="timeline-status"
                  :disabled="!isBillDelivered"
                />
                <div v-if="isBillDelivered">
                  <b> {{ data.delivered_by_fullname }} </b>
                  <div class="mb-1">
                    {{ data.delivered_at && formatedDate(data.delivered_at, 'DD-MM-YYYY LT') || '-' }}
                  </div>
                  <b-button
                    variant="outline-primary"
                    :disabled="unDeliverLoader"
                    @click="handleStatusChange('UN-DELIVER')"
                  > UnDeliver
                    <b-spinner
                      v-if="unDeliverLoader"
                      label="Small Spinner"
                      variant="primary"
                      small
                    />
                  </b-button>
                </div>
                <span v-else> Pending  </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div
        v-if="billData.bill_delivery_info"
        class="mt-2"
      >
        <BillDeliveryInfo :item="billData.bill_delivery_info" />
      </div>
      <div>
        <b-table-simple
          responsive
          hover
          class="compact-table"
        >
          <b-tbody>
            <b-tr>
              <b-th> Packing Initiated At :</b-th>
              <b-td> {{ billData.rack_group_status && billData.rack_group_status.packing_initiated_at && formatedDate(billData.rack_group_status.packing_initiated_at, 'DD-MM-YYYY LT') || '-' }} </b-td>
              <b-th> Packing Completed At :</b-th>
              <b-td> {{ billData.rack_group_status && billData.rack_group_status.packing_completed_at && formatedDate(billData.rack_group_status.packing_completed_at, 'DD-MM-YYYY LT') || '-' }} </b-td>
            </b-tr>
            <b-tr>
              <b-th> Invoice Items : {{ billData.items_count }} </b-th>
              <b-td />
              <b-th />
              <b-td />
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>

      <div>
        <b-tabs v-if="billData.rack_group_status">
          <b-tab
            title="Items Details"
            :active="mode === 'items'"
          >
            <b-table
              v-if="billData.rack_group_status.invoice_items"
              striped
              hover
              class="compact-table"
              :fields="tableColumns"
              :items="billData.rack_group_status.invoice_items"
            />
          </b-tab>
          <b-tab
            title="Comparison Details"
            :active="mode === 'difference'"
          >
            <div
              v-if="billData.rack_group_status.difference_html_available"
              id="content-holder"
              v-html="billData.rack_group_status.difference_html"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BTableSimple, BTr, BTh, BTd, BTable, BTbody, BSpinner, BAlert, BButton, BTab,
  BTabs,
} from 'bootstrap-vue'
import dateMixin from '@/mixins/dateMixin'
import Status from '@/components/Delivery/DeliveryStatus/Status.vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formatMixin from '@/mixins/formatMixin'
import BillDeliveryInfo from '../Delivery/BillDeliveryInfo.vue'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BTableSimple,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTable,
    BTab,
    BTabs,
    Status,
    BSpinner,
    BAlert,
    BButton,
    BillDeliveryInfo,
  },
  mixins: [dateMixin, formatMixin],
  props: {
    value: { type: Boolean, default: false },
    billId: { type: Number, required: true },
    billData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      data: null,
      loading: false,
      errorMessage: '',
      mode: 'items',
      unpickedLoader: false,
      unDeliverLoader: false,
      tableColumns: ['product', 'pack', 'rack_no', 'rack_group_no', 'quantity', 'batch', 'expiry', 'rate', 'mrp', 'company'],
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      },
    },
    isBillPicked() {
      return this.data && (this.data.picked_at || this.data.picked_by_fullname)
    },
    isBillDelivered() {
      return this.data && (this.data.delivered_at || this.data.delivered_by_fullname)
    },
  },
  mounted() {
    this.fetchBillDetail()
  },
  methods: {
    async fetchBillDetail() {
      try {
        this.loading = true
        const { data } = await axios.get(`/delivery/delivery_bills/${this.$props.billId}/`)
        this.data = data
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to View bill!'
      } finally {
        this.loading = false
      }
    },
    async handleStatusChange(status) {
      try {
        this.errorMessage = ''
        if (status === 'UN-PICK') {
          this.unpickedLoader = true
        } else if (status === 'UN-DELIVER') {
          this.unDeliverLoader = true
        }
        const { data } = await axios.post('/delivery/update_bills_status', {
          bills_delivery_id: [this.data.id],
          action: status,
        })

        await this.fetchBillDetail()
        this.$emit('onStatusChange')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: data.detail,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to View bill!'
      } finally {
        this.unpickedLoader = false
        this.unDeliverLoader = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.timeline-wrapper {
    position: relative;

}
.timeline-line {
    position: absolute;
    left: 0;
    right: 0;
    top: -3px;
    width: 90%;
}

.timeline-status {
    margin-bottom: 4px;
}
</style>
